import appConfig from '../../config/appConfig';
import * as backendTypes from '../../consts/app/backendTypes';

const isGamBackend = () => appConfig.getBackendType() === backendTypes.GAM_BACKEND;
const isUamBackend = () => appConfig.getBackendType() === backendTypes.UAM_BACKEND;

export default {
    isGamBackend,
    isUamBackend,
};
